export const External_navlist = [{
		title: '概况中心',
		icon: 'icon-a-lujing1',
		arrowShow: false,
		path: '/home',
		son: [{
				title: '概况首页',
				path: '/home/homepage',
			},
			{
				title: '聚合搜索',
				path: '/home/aggresearch',
			},
		],
	},
	{
		title: '引流获客',
		arrowShow: false,
		icon: 'icon-bingji1',
		iconstyle: 'font-size: 15px;',
		path: '/get_customers',
		son: [
			
			{
				title: '智能名片',
				path: '/get_customers/intellig',
				son: [{
						title: '我的名片',
						path: '/get_customers/intellig/mycard',
					},
					{
						title: '全部名片',
						path: '/get_customers/intellig/allcard',
					},
				],
			},
			{
				title: '文章获客',
				path: '/get_customers/information',
				son: [{
						title: '企业文章',
						path: '/get_customers/information/library',
					},
					{
						title: '行业文章',
						path: '/get_customers/information/hot_text',
					},
					{
						title: '我的分享',
						path: '/get_customers/information/share',
					},

				],
			},
			{
				title: '产品获客',
				path: '/get_customers/product',
				son: [{
						title: '全部产品',
						path: '/get_customers/product/all_product',
					},
					{
						title: '我的分享',
						path: '/get_customers/product/my_share',
					},
				],
			},
			{
				title: '海报获客',
				path: '/get_customers/poster',
				son: [{
						title: '公共海报',
						path: '/get_customers/poster/imgs',
					},
					{
						title: '企业海报',
						path: '/get_customers/poster/enterprise',
					},
					{
						title: '我的海报',
						path: '/get_customers/poster/my_poster',
					},
				],
			},
			{
				title: '活码获客',
				path: '/get_customers/live_code',
				son: [{
						title: '渠道活码',
						path: '/get_customers/live_code/code_list',
					},
					{
						title: '数据详情',
						path: '/get_customers/live_code/code_details',
					},

				],
			},
			{
				title: '获客简报',
				path: '/get_customers/brieguest',
			},
		],
	},
	{
		title: '云盘素材',
		arrowShow: false,
		icon: 'icon-a-bingji11',
		iconstyle: 'font-size: 12px;',
		path: '/source_material',
		son: [
			
			{
				title: '云盘素材',
				path: '/source_material/enterprise_file',
			},
			{
				title: '回收站',
				path: '/source_material/recycle_bin',
			},
			{
				title: '素材简报',
				path: '/source_material/briematerial',
			},
		],
	},
	{
		title: '客户运营',
		arrowShow: false,
		icon: 'icon-a-bingji21',
		path: '/customer',
		son: [
			
			{
				title: '客户列表',
				path: '/customer/customer_list',
				son: [
					{
						title: '客户列表',
						path: '/customer/customer_list',
					},
					{
						title: '新建客户',
						path: '/customer/customer_list',
						newbuilt: 1,
					},
				],
			},
			{
				title: '联系人',
				path: '/customer/contactlist',
				son: [
					{
						title: '联系人列表',
						path: '/customer/contactlist',
					},
					{
						title: '新建联系人',
						path: '/customer/contactlist',
						newbuilt: 1,
					},
				],
			},
			{
				title: '线索列表',
				path: '/customer/cue_pool',
				son: [
					{
						title: '线索列表',
						path: '/customer/cue_pool',
					},
					{
						title: '新建线索',
						path: '/customer/cue_pool',
						newbuilt: 1,
					},
				],
			},
			{
				title: '公海资源',
				path: '/customer/international',
				son: [
					{
						title: '线索公海',
						path: '/customer/international/cue_public',
					},
					{
						title: '新建公海线索',
						path: '/customer/international/cue_public',
						newbuilt: 1,
					},
					{
						title: '客户公海',
						path: '/customer/international/PublicCustomer',
					},
					{
						title: '新建公海客户',
						path: '/customer/international/PublicCustomer',
						newbuilt: 1,
					},
				],
			},
			{
				title: '跟进记录',
				path: '/customer/follow_up_record',
				son: [
					{
						title: '跟进记录',
						path: '/customer/follow_up_record',
					},
					{
						title: '新建记录',
						path: '/customer/follow_up_record',
						newbuilt: 1,
					},
				],
			},
			{
				title: '跟进计划',
				path: '/customer/follow_up_plan',
				son: [
					{
						title: '跟进计划',
						path: '/customer/follow_up_plan',
					},
					{
						title: '新建计划',
						path: '/customer/follow_up_plan',
						newbuilt: 1,
					},
				],
			},
			{
				title: '客户任务',
				path: '/customer/task',
			},
			{
				title: '客户简报',
				path: '/customer/briecustomer',
			},
		],
	},
	{
		title: '销售管理',
		arrowShow: false,
		icon: 'icon-a-bingji3',
		path: '/operate',
		son: [
			
			{
				title: '商机列表',
				path: '/operate/opportlist',
				son: [
					{
						title: '商机列表',
						path: '/operate/opportlist',
					},
					{
						title: '新建商机',
						path: '/operate/opportlist',
						newbuilt: 1,
					},
				],
			},
			{
				title: '项目列表',
				path: '/operate/projectlist',
				son: [
					{
						title: '项目列表',
						path: '/operate/projectlist',
					},
					{
						title: '新建项目',
						path: '/operate/projectlist',
						newbuilt: 1,
					},
				],
			},
			{
				title: '合同列表',
				path: '/operate/contractlist',
				son: [
					{
						title: '合同列表',
						path: '/operate/contractlist',
					},
					{
						title: '新建合同',
						path: '/operate/contractlist',
						newbuilt: 1,
					},
				],
			},
			{
				title: '回款列表',
				path: '/operate/lectionlist',
				son: [
					{
						title: '回款列表',
						path: '/operate/lectionlist',
					},
					{
						title: '新建回款',
						path: '/operate/lectionlist',
						newbuilt: 1,
					},
				],
			},
			{
				title: '订单列表',
				path: '/operate/orderlist',
				son: [
					{
						title: '订单列表',
						path: '/operate/orderlist',
					},
					{
						title: '新建订单',
						path: '/operate/orderlist',
						newbuilt: 1,
					},
				],
			},
			{
				title: '报价单列表',
				path: '/operate/quotatlist',
				son: [
					{
						title: '报价单列表',
						path: '/operate/quotatlist',
					},
					{
						title: '新建报价单',
						path: '/operate/quotatlist',
						newbuilt: 1,
					},
				],
			},
			{
				title: '销售简报',
				path: '/operate/briesale',
			},
		],
	},
	// {
	// 	title: '项目管理',
	// 	arrowShow: false,
	// 	icon: 'icon-a-fenzu7',
	// 	iconstyle: 'font-size: 14px;',
	// 	path: '/project',
	// 	son: [{
	// 			title: '项目列表',
	// 			path: '/project/projectlist',
	// 		},
	// 		{
	// 			title: '项目需求',
	// 			path: '/project/demandlist',
	// 		},
	// 		{
	// 			title: '项目任务',
	// 			path: '/project/tasklist',
	// 		},
	// 		{
	// 			title: '项目问题',
	// 			path: '/project/troublelist',
	// 		},
	// 	],
	// },
	{
		title: '企业微信',
		arrowShow: false,
		icon: 'icon-a-lujing11',
		path: '/qiwei',
		son: [{
				title: '消息存档',
				path: '/qiwei/file/news_file',
			},
			{
				title: '流失提醒',
				path: '/qiwei/loss_remind',
			},
			{
				title: '删人提醒',
				path: '/qiwei/del_remind',
			},
			{
				title: '群列表',
				path: '/qiwei/group_list',
			},
			{
				title: '群标签',
				path: '/qiwei/group_label',
			},
			{
				title: '群群发',
				path: '/qiwei/group_mass',
			},
			{
				title: '群任务',
				path: '/qiwei/group_task',
			},
		],
	},
	{
		title: '数据分析',
		arrowShow: false,
		icon: 'icon-a-lujing12',
		path: '/data',
		son: [{
			title: '获客数据',
			path: '/data/bulletinboard',
		}, ],
	},
	{
		title: '系统设置',
		arrowShow: false,
		icon: 'icon-a-bingji4',
		path: '/set_up',
		son: [{
				title: '系统设置',
				path: '/set_up/system_settings',
			},
			{
				title: '企业微信',
				path: '/set_up/WeCom',
				son: [{
						title: '企业微信',
						path: '/set_up/WeCom/wechat',
					},
					{
						title: '企微设置',
						path: '/set_up/WeCom/ChatBar',
					},
				],
			},
			{
				title: '访问数据',
				path: '/set_up/access_data',
				son: [{
						title: '访问数据',
						path: '/set_up/access_data',
					},
					{
						title: '列表数据',
						path: '/set_up/access_data',
					},
				],
			},
			{
				title: '消息提醒',
				path: '/set_up/message',
			},
			{
				title: '成员角色',
				path: '/set_up/memberset',
				son: [{
						title: '成员管理',
						path: '/set_up/memberset/member',
					},
					{
						title: '角色管理',
						path: '/set_up/memberset/role',
					},
				],
			},
			{
				title: '获客设置',
				path: '/set_up/hkset',
				son: [{
						title: '获客设置',
						path: '/set_up/hkset/guest',
					},
					{
						title: '名片装修',
						path: '/set_up/hkset/renovation',
					},
					{
						title: '接入官网',
						path: '/set_up/hkset/official_website',
					},
					{
						title: '接入商城',
						path: '/set_up/hkset/mall',
					},
					{
						title: '产品单位',
						path: '/set_up/hkset/goodunit',
					},

				],
			},
			{
				title: '云盘设置',
				path: '/set_up/Cloud',
				son: [{
					title: '云盘设置',
					path: '/set_up/Cloud/materialset',
				}, ],
			},
			
			{
				title: '项目设置',
				path: '/set_up/project',
				son: [
					{
						title: '模块设置',
						path: '/set_up/project',
					},
				],
			},
			{
				title: '客户设置',
				path: '/set_up/kehu_set',
				son: [

					{
						title: '模块设置',
						path: '/set_up/kehu_set/customer_info_div',
					},
					{
						title: '跟进阶段',
						path: '/set_up/kehu_set/follow_up_stage',
					},
					{
						title: '跟进方式',
						path: '/set_up/kehu_set/follow_up_mode',
					},
					{
						title: '跟进类型',
						path: '/set_up/kehu_set/follow_up_type',
					},
					{
						title: '客户来源',
						path: '/set_up/kehu_set/kehu_source',
					},
					{
						title: '客户标签',
						path: '/set_up/kehu_set/kehu_label',
					},
					{
						title: '行为打标签',
						path: '/set_up/kehu_set/add_group',
					},
					{
						title: '分时段打标签',
						path: '/set_up/kehu_set/day_part',
					},
				],
			},
			{
				title: '销售设置',
				path: '/set_up/setxs',
				son: [

					{
						title: '商机设置',
						path: '/set_up/setxs/opport',
					},
					{
						title: '项目设置',
						path: '/set_up/setxs/project',
					},
					{
						title: '合同设置',
						path: '/set_up/setxs/contract',
					},
					{
						title: '回款设置',
						path: '/set_up/setxs/lection',
					},
					{
						title: '订单设置',
						path: '/set_up/setxs/order_set',
					},
					{
						title: '报价单设置',
						path: '/set_up/setxs/quotation_set',
					},
				],
			},
			// 				{
			// 					title: '项目设置',
			// 					path: '/set_up/project',
			// 					son: [{
			// 							title: '项目设置',
			// 							path: '/set_up/project/project_info_div',
			// 						},

			// 					],
			// 				},

		],
	},
]